import { Theme } from '@material-ui/core/styles'

/**
 * @returns {Theme} the designated theme object
 */
const loadTheme = async (): Promise<Theme> => {
    const url = new URL(window.location.href)
    const themeType = (url.searchParams && url.searchParams.get('theme')) || process.env.REACT_APP_THEME

    // 1. Import just the theme we want (to avoid recursively importing things we don't need)
    // NOTE:  the import() function must be passed a string literal (cannot be generalized by passing in a variable)
    let theme
    switch (themeType) {
            case 'Revenuewell':
                theme = (await import('revenuewell-theme')).revenuewellTheme
                break
            case 'ConfigureApp':
                theme = (await import('configure-app-theme')).configureAppTheme
                break
            case 'ConsoleApp':
                theme = (await import('console-app-theme')).consoleAppTheme
                break
            case 'MyPdc':
                theme = (await import('my-pdc-theme')).myPdcTheme
                break
            case 'SignUpTheme':
                theme = (await import('sign-up-theme')).signUpTheme
                break
            default:
                theme = (await import('themes')).mainTheme
    }

    // 2. Set Page Title
    if (theme.appName) {
        window.document.title = theme.appName
    }

    // 3. Set FavIcon
    if (!global.isJest && theme.favicon?.default) {
        try {
            document.getElementsByName('favicon')[0].href = theme.favicon.default
        } catch (e) {
            console.warn('could not change favicon in theme')
        }
    }

    return theme
}

export default loadTheme
